import { c as _c } from "react/compiler-runtime";
import { Provider } from '@repo/api-gw-sdk';
import { ButtonWithIcon } from '../buttons/buttonWithIcon';
import { getCloudFieldConfig } from '../form/validation/cloudFieldValidation';
const generateKmsKeyUrl = (kmsArn?: string) => {
  const kmsRegion = kmsArn?.split('arn:aws:kms:')[1]?.split(':')[0];
  const baseUrl = `https://${kmsRegion}.console.aws.amazon.com/kms/home?region=${kmsRegion}#/kms/keys`;
  const kmsId = kmsArn?.split(':key/')[1];
  return kmsId ? `${baseUrl}/${kmsId}/editPolicy` : baseUrl;
};
const arnConfig = getCloudFieldConfig(Provider.Aws, 'kmsKeyArn');
export const KmsEditKeyPolicyButton = t0 => {
  const $ = _c(7);
  const {
    kmsKey
  } = t0;
  let t1;
  if ($[0] !== kmsKey) {
    t1 = !kmsKey || !arnConfig.validation.validateInput(kmsKey);
    $[0] = kmsKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const disabled = t1;
  let t2;
  if ($[2] !== kmsKey) {
    t2 = () => window.open(generateKmsKeyUrl(kmsKey), "_blank");
    $[2] = kmsKey;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== disabled || $[5] !== t2) {
    t3 = <ButtonWithIcon variant="contained" disabled={disabled} text="Edit Key Policy in AWS" icon="material-symbols-open-in-new" iconPosition="right" onClick={t2} />;
    $[4] = disabled;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};